import { render, staticRenderFns } from "./EnderecoForm.vue?vue&type=template&id=3a18ce56&scoped=true&"
import script from "./EnderecoForm.vue?vue&type=script&lang=js&"
export * from "./EnderecoForm.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoForm.vue?vue&type=style&index=0&id=3a18ce56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18ce56",
  null
  
)

export default component.exports